<div class="hps-wrapper">

  <!-- BARRE D'ACTIONS -->
  <div class="hps-toolbar no-print">
    <div class="hps-toolbar__info">
      <span class="hps-toolbar__title">Historique des paramètres santé</span>
      <span class="hps-toolbar__count" *ngIf="totalElements">{{ totalElements }} consultation(s)</span>
      <span class="hps-toolbar__pagesize" *ngIf="totalPages > 0">
        Page {{ currentPage + 1 }}/{{ totalPages }} — 10 par page
      </span>
    </div>
    <button class="hps-btn hps-btn--primary" (click)="print()">
      <i class="feather feather-printer"></i>
      Imprimer
    </button>
  </div>

  <!-- CONTENU IMPRIMABLE -->
  <div class="hps-print-section" #printSection>

    <div class="print-header">
      <h4>Dossier Patient — Historique paramètres santé</h4>
      <p><strong>Nom :</strong> {{ patient.getFullName() }} &nbsp; | &nbsp;
         <strong>Naissance :</strong> {{ patient.birthDate | date : 'dd/MM/yyyy' }} &nbsp; | &nbsp;
         <strong>Âge :</strong> {{ age }} ans</p>
      <p *ngIf="patient.address"><strong>Adresse :</strong> {{ patient.address }}</p>
    </div>

    <div class="print-body">

      <!-- ÉTAT DE CHARGEMENT -->
      <div class="hps-loading no-print" *ngIf="loading">
        <div class="hps-spinner"></div>
        <span>Chargement de l'historique…</span>
      </div>

      <!-- TABLEAU -->
      <div class="hps-table-scroll" *ngIf="!loading && patientHistorics.length > 0">
        <table class="hps-table">
          <thead>
            <tr>
              <th class="hps-col-sticky hps-corner">Paramètre</th>
              <th *ngFor="let historic of patientHistorics" class="hps-date-col">
                <div class="hps-date-col__date">{{ historic.date | date : 'dd/MM/yyyy' }}</div>
                <div class="hps-date-col__time">{{ historic.time }}</div>
                <div class="hps-motifs" *ngIf="historic.motifs?.length">
                  <span
                    class="hps-badge"
                    *ngFor="let motif of historic.motifs"
                    [style.background]="motif.color"
                  >{{ motif.name }}</span>
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let param of paramList" class="hps-param-row">
              <td class="hps-col-sticky hps-param-label">
                {{ param.label }}
                <span class="hps-unit" *ngIf="param.unit">({{ param.unit }})</span>
              </td>
              <td *ngFor="let historic of patientHistorics" class="hps-value-cell">
                {{ getParamValue(historic, param.id) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ÉTAT VIDE -->
      <div class="hps-empty" *ngIf="!loading && patientHistorics.length === 0">
        <i class="feather feather-clipboard hps-empty__icon"></i>
        <p>Aucun historique de paramètres santé trouvé pour ce patient.</p>
      </div>

    </div>

    <div class="print-footer">
      <hr />
      <p><strong>Docteur :</strong> {{ doctor.firstName }} {{ doctor.lastName }}</p>
      <p *ngIf="doctor.address"><strong>Adresse :</strong> {{ doctor.address }}</p>
      <p *ngIf="doctor.mobilePhone1"><strong>Téléphone :</strong> {{ doctor.mobilePhone1 }}</p>
    </div>
  </div>

  <!-- PAGINATION -->
  <div class="hps-pagination no-print" *ngIf="totalPages > 1">
    <button class="hps-page-btn" (click)="prevPage()" [disabled]="currentPage === 0">‹ Précédent</button>

    <div class="hps-page-numbers">
      <button
        *ngFor="let p of pageNumbers"
        class="hps-page-number"
        [class.hps-page-number--active]="p === currentPage"
        (click)="goToPage(p)"
      >{{ p + 1 }}</button>
    </div>

    <button class="hps-page-btn" (click)="nextPage()" [disabled]="currentPage === totalPages - 1">Suivant ›</button>
  </div>

</div>